var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMessagerDeleteComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.1333 13.268L12.8 3.66797C12.0833 2.3763 11.0917 1.66797 10 1.66797C8.90833 1.66797 7.91666 2.3763 7.2 3.66797L1.86666 13.268C1.19166 14.493 1.11666 15.668 1.65833 16.593C2.2 17.518 3.26666 18.0263 4.66666 18.0263H15.3333C16.7333 18.0263 17.8 17.518 18.3417 16.593C18.8833 15.668 18.8083 14.4846 18.1333 13.268Z",
    fill: "#EA4545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.2917C9.65833 12.2917 9.375 12.0083 9.375 11.6667V7.5C9.375 7.15833 9.65833 6.875 10 6.875C10.3417 6.875 10.625 7.15833 10.625 7.5V11.6667C10.625 12.0083 10.3417 12.2917 10 12.2917Z",
    fill: "#EA4545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.0008C9.95 15.0008 9.89166 14.9924 9.83333 14.9841C9.78333 14.9758 9.73333 14.9591 9.68333 14.9341C9.63333 14.9174 9.58333 14.8924 9.53333 14.8591C9.49166 14.8258 9.45 14.7924 9.40833 14.7591C9.25833 14.6008 9.16666 14.3841 9.16666 14.1674C9.16666 13.9508 9.25833 13.7341 9.40833 13.5758C9.45 13.5424 9.49166 13.5091 9.53333 13.4758C9.58333 13.4424 9.63333 13.4174 9.68333 13.4008C9.73333 13.3758 9.78333 13.3591 9.83333 13.3508C9.94166 13.3258 10.0583 13.3258 10.1583 13.3508C10.2167 13.3591 10.2667 13.3758 10.3167 13.4008C10.3667 13.4174 10.4167 13.4424 10.4667 13.4758C10.5083 13.5091 10.55 13.5424 10.5917 13.5758C10.7417 13.7341 10.8333 13.9508 10.8333 14.1674C10.8333 14.3841 10.7417 14.6008 10.5917 14.7591C10.55 14.7924 10.5083 14.8258 10.4667 14.8591C10.4167 14.8924 10.3667 14.9174 10.3167 14.9341C10.2667 14.9591 10.2167 14.9758 10.1583 14.9841C10.1083 14.9924 10.05 15.0008 10 15.0008Z",
    fill: "#EA4545"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMessagerDeleteComponent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-messager-delete-component.dcb4bad8073199e7df20a5167f427bf5.svg";